import React from 'react';
import { PageFrame } from '../components/PageFrame';
import { posts } from '../components/marketingContent';

type Props = {
  onPrimaryCta: () => void;
  onSecondaryCta: () => void;
};

export function BlogPage({ onPrimaryCta, onSecondaryCta }: Props) {
  return (
    <PageFrame title="Blog" onPrimaryCta={onPrimaryCta} onSecondaryCta={onSecondaryCta}>
      <section id="blog" className="section">
        <div className="container">
          <div className="section-heading">
            <div>
              <h1 className="section-title">Blog</h1>
              <h2 className="section-subtitle">Playbooks and engineering notes from the feed.</h2>
            </div>
            <p className="section-description">
              We document what we learn shipping filing-aware AI: production checklists, prompt guards, and desk
              playbooks you can reuse.
            </p>
          </div>
          <div className="blog-grid">
            {posts.map((post) => (
              <div className="blog-card" key={post.title}>
                <div className="meta">
                  <span>{post.tag}</span>
                  <span>|</span>
                  <span>{post.time}</span>
                </div>
                <h3>{post.title}</h3>
                <button className="cta-secondary" type="button" onClick={onPrimaryCta}>
                  Get started
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageFrame>
  );
}
